import React, { useState, useEffect } from 'react';
import { getEmployees } from '../api/api';
import { format } from 'date-fns';

function Employees({ user }) {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const response = await getEmployees();
      setEmployees(response.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container"><div className="loading">Chargement...</div></div>;
  }

  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <h2>👥 Employés</h2>
        </div>

        {employees.length === 0 ? (
          <p>Aucun employé enregistré.</p>
        ) : (
          <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Date d'embauche</th>
                <th>Rôle</th>
                <th>Statut</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((employee) => (
                <tr key={employee.id}>
                  <td>{employee.firstname} {employee.lastname}</td>
                  <td>{employee.email}</td>
                  <td>{employee.phone}</td>
                  <td>{format(new Date(employee.hire_date), 'dd/MM/yyyy')}</td>
                  <td>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.85rem',
                      background: employee.role === 'admin' ? '#e74c3c' : employee.role === 'manager' ? '#f39c12' : '#B8472E',
                      color: 'white'
                    }}>
                      {employee.role}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.85rem',
                      background: employee.status === 'active' ? '#27ae60' : '#95a5a6',
                      color: 'white'
                    }}>
                      {employee.status === 'active' ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Employees;
